'use client'
import { Amplify } from 'aws-amplify'
import cognito from '@/lib/cognito-config'

let configured = false

export function configureAmplifyClient(): void {
  if (configured) return
  Amplify.configure(
    {
      Auth: {
        Cognito: {
          userPoolId: cognito.userPoolId,
          userPoolClientId: cognito.userPoolClientId,
        },
      },
    },
    { ssr: true }
  )
  configured = true
}


